export const imagesConfig = [
  // {
  //   label: 'Logo',
  //   key: 'logoPhoto',
  //   placeholder: '+ Add Logo',
  //   countLimit: 1,
  //   photoIdKey: 'logoPhotoIds',
  // },
  // {
  //   label: 'Background Photo',
  //   tip: 'Recommended photo resolutions: 1920 x 520 px',
  //   key: 'backgroundPhoto',
  //   placeholder: '+ Add Background Photo',
  //   countLimit: 1,
  //   photoIdKey: 'backgroundPhotoIds',
  // },
  // {
  //   label: 'Portfolio Photos',
  //   key: 'portfolioPhoto',
  //   placeholder: '+ Add Portfolio Photos',
  //   countLimit: 20,
  //   photoIdKey: 'portfolioPhotoIds',
  // },
];

export const convertImagesToPublicDataInfo = (images, publicData) => {
  let publicDataInfo = {};

  imagesConfig.forEach(conf => {
    const photos = images.filter(img => img?.file?.name === conf.key);
    const newPhotoIds = photos.map(img => img?.imageId?.uuid);
    const alreadySavedPhotosIds = publicData[conf.photoIdKey] || [];
    const allPhotosArray = [...newPhotoIds, ...alreadySavedPhotosIds];
    //we remove the ids which do not exists anymore
    const filteredPhotosArray = allPhotosArray.filter(i =>
      images.find(x => x?.id?.uuid === i || x?.imageId?.uuid === i)
    );
    if (newPhotoIds?.length > 0) {
      publicDataInfo[conf.photoIdKey] = filteredPhotosArray;
    }
  });

  return publicDataInfo;
};

export const filterImagesValues = (key, images, publicData) => {
  // images.filter(img => img?.file?.name === key);
  const photoIdKey = imagesConfig.find(img => img?.key === key)?.photoIdKey;
  const photoIds = publicData[photoIdKey];

  const freshImages = images.filter(img => img?.file?.name === key);
  const alreadySavedImages = images.filter(
    img => photoIds?.length > 0 && img?.id?.uuid && photoIds.includes(img?.id?.uuid)
  );

  const finalImagesValues = [...alreadySavedImages, ...freshImages];

  return finalImagesValues;
};

export const replaceFileName = (file, newName) => {
  let parts = file.name.split('.');
  let ext = parts.pop();
  let changed = new File([file], newName, {
    //+ '.' + ext ->add this after 'newName'  if we want to add the extension too
    type: file.type,
    lastModified: file.lastModified,
  });
  return changed;
};
